import React, { FC, memo } from 'react'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Pagination } from '@ucheba/ui/components/Pagination/desktop'
import { useSelector } from 'react-redux'
import { specialitiesSearchSelectors } from '@ucheba/store/specialities/search'
import { specialitiesSearchLimit } from '@ucheba/store/specialities/search/constants'
import { ISpecialitiesSearchPagePaginationProps } from '../types'
import { useSpecialitiesSearchPagePaginationCore } from '../bll'

const SpecialitiesSearchPagePagination: FC<ISpecialitiesSearchPagePaginationProps> = (
  props
) => {
  const { isFriendlyUrlPage } = props
  const searchResults = useSelector(specialitiesSearchSelectors.selectAll)
  const { total, totalPages, currentPage, setCurrentPage, getHrefWithPage } =
    useSpecialitiesSearchPagePaginationCore(props)

  if (!searchResults.length) return null

  return (
    <>
      <Spacing spacing='xlarge' />

      <Grid justifyContent='space-between' alignItems='center'>
        <GridCol width='auto'>
          <Text fontWeight='bold'>{`Всего: ${total}`}</Text>
        </GridCol>

        <GridCol width='auto'>
          {total > specialitiesSearchLimit && (
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              changePageHandler={setCurrentPage}
              getHrefWithPage={isFriendlyUrlPage ? getHrefWithPage : undefined}
            />
          )}
        </GridCol>
      </Grid>
    </>
  )
}

export default memo(SpecialitiesSearchPagePagination)
